<div class="user-delegation-view">

    <div class="modal-header">
        <h2 class="modal-title" translate="Delegations.Title"></h2>
    </div>

    <div class="modal-body" [class.block-loader]="loader.isLoading">
        <loader-spinner [model]="loader"/>

        @if (delegations$ | async; as delegations) {
            @if (!delegations.userRoleDelegations.length && !delegations.superDebtorDelegations.length) {
                {{ 'Delegations.NoDelegationsAtAll' | translate }}
            } @else {
                <h3 translate="Delegations.RolesDelegation"></h3>
                <div class="user-delegation-view-roles table-responsive col-12 mb-4">
                    <table class="table table-hover table-sortable">
                        <thead class="thead-light">
                            <th translate="Delegations.DelegateUser"></th>
                            <th translate="Delegations.EndOn"></th>
                            <th translate="Delegations.Role"></th>
                        </thead>
                        <tbody>
                            @for (d of delegations.userRoleDelegations; track d) {
                                <tr>
                                    <td>{{ d.userName }}</td>
                                    <td>{{ d.end | dateFormat }}</td>
                                    <td>{{ roleLabelFn(d.role) | translate }}</td>
                                </tr>
                            } @empty {
                                <tr table-row-empty message="Delegations.NoDelegations"></tr>
                            }
                        </tbody>
                    </table>
                </div>

                <h3 translate="Delegations.ClientsDelegation"></h3>
                <div class="user-delegation-view-clients table-responsive col-8">
                    <table class="table table-hover table-sortable">
                        <thead class="thead-light">
                            <th translate="Delegations.DelegateUser"></th>
                            <th translate="Delegations.EndOn"></th>
                        </thead>
                        <tbody>
                            @for (d of delegations.superDebtorDelegations; track d) {
                                <tr>
                                    <td>{{ d.userName }}</td>
                                    <td>{{ d.end | dateFormat }}</td>
                                </tr>
                            } @empty {
                                <tr table-row-empty message="Delegations.NoDelegations"></tr>
                            }
                        </tbody>
                    </table>
                </div>
            }
        }
    </div>

	<div class="modal-footer d-flex flex-row-reverse">
        <button type="button" class="btn btn-default"
                (click)="activeModal.close()"
                translate="Actions.Close" data-cy="Close"></button>
    </div>
</div>
